<template>
  <div class="s-best-sellers">
    <div class="page-container">
      <div class="h2 mb-24">{{ title }}</div>

      <div class="s-best-sellers__items">
        <div
          v-for="(item, index) in records"
          :key="index"
          class="s-best-sellers__item">
          <BestSellers :item="item" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as lib from '../../lib/lib'
import BestSellers from '../components/BestSellers.vue'

export default {
  components: { BestSellers },

  data() {
    return {
      title: '',
      records: [],
    }
  },
  mounted() {
    const { title, records } = lib.getData('bestSellersData')
    this.records = records
    this.title = title
  },
}
</script>
